export default {
    name: "characters",
    methods: {
        charactersOver80: function(text) {
            if (!text) {
                return false;
            } else if (text.length > 80) {
                return true;
            } else {
                return false;
            }
        },
        cutOff: function(text) {
            let slice = text.slice(0, 79);
            slice = slice + "[...]";
            return slice;
        }
    }
}